import { motion } from "framer-motion";

/* Friendly enterprise AI robot — animated (blinking eyes, floating, scanning) */
export const RobotGraphic = ({ className = "" }) => (
  <motion.div
    aria-hidden
    className={`relative ${className}`}
    animate={{ y: [0, -14, 0] }}
    transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
  >
    <svg viewBox="0 0 240 260" className="h-full w-full overflow-visible">
      <defs>
        <linearGradient id="rbody" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1F5A72" />
          <stop offset="100%" stopColor="#123C52" />
        </linearGradient>
        <linearGradient id="rface" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#0E7F8C" />
          <stop offset="100%" stopColor="#0A2A38" />
        </linearGradient>
        <radialGradient id="reye" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#F5C542" />
          <stop offset="100%" stopColor="#E0A81E" />
        </radialGradient>
      </defs>

      {/* antenna */}
      <line x1="120" y1="34" x2="120" y2="14" stroke="#0E8F9E" strokeWidth="4" strokeLinecap="round" />
      <motion.circle cx="120" cy="10" r="7" fill="url(#reye)"
        animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.6, repeat: Infinity }} />

      {/* head */}
      <rect x="52" y="34" width="136" height="104" rx="26" fill="url(#rbody)" stroke="#2AA9B8" strokeWidth="2" />
      {/* face screen */}
      <rect x="66" y="50" width="108" height="74" rx="18" fill="url(#rface)" />
      {/* eyes */}
      <motion.g animate={{ scaleY: [1, 1, 0.1, 1, 1] }} transition={{ duration: 4, repeat: Infinity, times: [0, 0.45, 0.5, 0.55, 1] }} style={{ transformOrigin: "120px 82px" }}>
        <circle cx="98" cy="82" r="11" fill="url(#reye)" />
        <circle cx="142" cy="82" r="11" fill="url(#reye)" />
      </motion.g>
      {/* smile */}
      <path d="M100 104 Q120 116 140 104" stroke="#29B3C2" strokeWidth="4" fill="none" strokeLinecap="round" />
      {/* scanning line */}
      <motion.rect x="66" y="50" width="108" height="4" rx="2" fill="#F5C542" opacity="0.5"
        animate={{ y: [50, 118, 50] }} transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }} />

      {/* ears */}
      <rect x="42" y="70" width="10" height="34" rx="5" fill="#0E8F9E" />
      <rect x="188" y="70" width="10" height="34" rx="5" fill="#0E8F9E" />

      {/* body */}
      <rect x="68" y="146" width="104" height="86" rx="22" fill="url(#rbody)" stroke="#2AA9B8" strokeWidth="2" />
      <circle cx="120" cy="182" r="15" fill="url(#rface)" />
      <motion.circle cx="120" cy="182" r="6" fill="#F5C542"
        animate={{ opacity: [1, 0.3, 1] }} transition={{ duration: 2, repeat: Infinity }} />
      <rect x="86" y="210" width="68" height="8" rx="4" fill="#0E7F8C" />

      {/* arms */}
      <motion.rect x="44" y="150" width="16" height="58" rx="8" fill="url(#rbody)"
        animate={{ rotate: [0, -10, 0] }} transition={{ duration: 3.5, repeat: Infinity }} style={{ transformOrigin: "52px 150px" }} />
      <motion.rect x="180" y="150" width="16" height="58" rx="8" fill="url(#rbody)"
        animate={{ rotate: [0, 12, 0] }} transition={{ duration: 3, repeat: Infinity }} style={{ transformOrigin: "188px 150px" }} />
    </svg>
    {/* glow */}
    <div className="absolute inset-0 -z-10 m-auto h-2/3 w-2/3 rounded-full bg-teal/30 blur-3xl" />
  </motion.div>
);
